// extracted by mini-css-extract-plugin
module.exports = {"projectCardList":"projectList-module--projectCardList--2e8E7"};